<template>
  <!-- 'is-folded-aside': isFolded, -->
  <div
    class="aside"
    :class="{ 'is-show-mask-aside': isShowMask }"
    id="skeleton-aside"
  >
    <!--   -->
    <a
      @mouseenter="handleShowUserRightDetail"
      @mouseleave="showUserRightDetail = false"
      class="logo-wrapper"
      data-io-click="tracker"  @click="logoClick()"
    >
      <!-- <img
        class="logo"
        v-if="userInfo.schoolLogo && !textbook.isInIframe"
        :src="userInfo.schoolLogo"
        alt=""
      /> -->
      <img
        v-if="!userInfo.schoolLogo && !textbook.isInIframe"
        class="logo"
        src="@/assets/images/new-logo.png"
        alt=""
      />
      <div class="user-right-wrapper" v-if="showUserRightDetail">
        <div class="user-right-inner">
          <div class="menu-group">
            <div class="menu-title">学校</div>
            <div class="menu-info">{{ userInfo.schoolName }}</div>
          </div>
          <div class="menu-group">
            <div class="menu-title">服务</div>
            <div
              class="menu-info"
              v-for="(item, index) in userInfo.roles"
              :key="index"
            >
              <span>{{ item.roleName }}</span
              >（剩余<span>{{ item.validDays }}</span
              >天）
            </div>
            <div
              class="menu-info"
              v-if="
                userInfo.resourceCardVO &&
                userInfo.resourceCardVO.resourceCardBalance
              "
            >
              <span>学科网通享卡</span>({{
                userInfo.resourceCardVO.schoolChargeUsedType == 1
                  ? "学校共享"
                  : "个人"
              }}余额<span>{{
                userInfo.resourceCardVO.resourceCardBalance.toFixed(2)
              }}</span
              >元)
            </div>
          </div>
        </div>
      </div>
    </a>
    <TopNavSearch
      size="mini"
      placeHolderText="搜索"
      :isShowInput="!isFolded"
      v-if="isShowFunction"
    />
    <div
      class="link-wrapper"
      ref="linkWrapper"
      @mouseenter="handleFirstEnterLinks"
    >
      <SideNav
        @toPath="toPath"
        @toLoginLayout="toLoginLayout"
        @openNoAuthDialog="openNoAuthDialog"
        :loginStatus="loginStatus"
        :enterWxtStatus="enterWxtStatus"
        :navs="menus"
        @toggle="toggle"
      />
      <div class="occupy-box"></div>
    </div>
    <!-- @mouseenter="userInfoEnter()"
    @mouseleave="showUserInfoDetail = false" -->
    <div
      class="bottom-menu"
      :class="{ 'margin-top-style': showScrollIcon }"
      @mouseenter="showUserInfoDetail = true"
      @mouseleave="showUserInfoDetail = false"
    >
      <!-- 用户权益入口 -->
      <!-- @mouseenter="showUserInfoDetail = true"
        @mouseleave="showUserInfoDetail = false" -->
      <!-- @mouseleave="showUserInfoDetail = false" -->
      <!--  -->
      <div class="user-info-wrapper" data-io-click="tracker"  @click="userInfoClick()">
        <div
          class="user-info-box"
          :class="{ 'no-login': !loginStatus || !enterWxtStatus }"
        >
          <div style="color: black" v-if="!loginStatus">登录</div>
          <div style="color: black" v-else-if="loginStatus && !enterWxtStatus">
            无权限用户
          </div>
          <img v-else :src="userInfo.faceImg" alt="" />
          <div class="user-info-name" v-if="loginStatus && enterWxtStatus">
            <div class="name">
              {{ userInfo.nickName || userInfo.loginName }}
            </div>
            <!-- <div class="house">你的线上教研室</div> -->
          </div>
          <i class="iconfont icon-ellipsis more-icon"></i>
        </div>
        <div class="menu" v-show="showUserInfoDetail">
          <div class="menu-inner">
            <div class="user-info">
              <img :src="userInfo.faceImg" alt="" />
              <div class="user-info-name">
                <div class="name">
                  {{ userInfo.nickName || userInfo.loginName }}
                </div>
                <div class="house">{{ userInfo.schoolName }}</div>
              </div>
            </div>
            <div>
              <div class="menu-group">
                <div class="item">帮助</div>
                <a
                  href="https://webchat-bj.clink.cn/chat.html?accessId=b99757dc-4d2a-4219-83bb-46289b108c8a&tinetWebChatType=tinetResponsive&language=zh_CN"
                  target="_blank"
                  class="item"
                  ><i class="iconfont icon-headphones"></i>在线客服</a
                >
                <a href="/user/problem" target="_blank" class="item"
                  ><i class="iconfont icon-feedback1"></i>问题反馈</a
                >
                <a
                  target="_blank"
                  href="https://www.zxxk.com/service/"
                  class="item"
                  ><i class="iconfont icon-help1"></i>帮助文档</a
                >
              </div>
              <div class="menu-group">
                <div class="item">个人</div>
                <span v-if="isShowFunction" class="item" data-io-click="tracker"  @click="openSetting"
                  ><i class="iconfont icon-preference"></i>偏好设置</span
                >
                <span class="item" data-io-click="tracker"  @click="openUserPage">
                  <i class="iconfont icon-user-settings"></i>个人中心
                </span>
              </div>
              <div class="menu-group" v-if="userInfo.isAdmin">
                <div class="item">学校</div>
                <a
                  v-if="userInfo.isAdmin && !textbook.isOnlyScsy"
                  href="//admin-wxt.xkw.com"
                  target="_blank"
                  class="item"
                  ><i class="iconfont icon-Power"></i>权限管理</a
                >
                <a
                  v-if="userInfo.isAdmin"
                  class="item"
                  href="https://ss.xkw.com"
                  target="_blank"
                >
                  <i class="iconfont icon-Management"></i>管理后台
                </a>
              </div>
            </div>
            <a class="item logout" :href="logoutUrl">
              <i class="iconfont icon-logout"></i>退出登录
            </a>
          </div>
        </div>
        <!-- <i v-if="!isFolded" class="iconfont icon-down-arrow"></i> -->
      </div>
    </div>

    <div class="mask" v-if="isShowMask" :style="maskStyle"></div>
  </div>
</template>
<script>
// import { mapState } from "vuex";
// import { menus } from "@/utils/stateList";
const SHOWWEIXINCODE = "SHOWWEIXINCODE";
import api from "@/assets/js/service/api";
import SideNav from "@/components/SideNav.vue";
import TopNavSearch from "@/components/TopNavSearch.vue";
import { beikeHost } from "@/utils/apis";
import { mapMutations, mapState } from "vuex";
// 显示更新icon
const SHOWBKUPDATEICON = "SHOWBKUPDATEICON";
// 初次进入左侧导航
const FIRSTENTERLEFTLINKS = "FIRSTENTERLEFTLINKS";
// 打开的左侧导航id
const OPENSIDENAVLISTS = "OPENSIDENAVLISTS";
export default {
  props: {
    loginStatus: {
      type: Boolean,
      default: false,
    },
    enterWxtStatus: {
      type: Boolean,
      default: false,
    },
    menus: {
      type: Array,
      default() {
        return [];
      },
    },
    isShowMask: {
      type: Boolean,
      default: false,
    },
    maskStyle: {
      type: Object,
      default: null,
    },
  },
  components: {
    TopNavSearch,
    SideNav,
  },
  data() {
    return {
      loginPopupVisible: false,
      isChangeChild: false,
      // 是否显示二维码
      showWeixinCode: false,
      showUserInfoDetail: false,
      showUserRightDetail: false,
      logoutUrl: api.auth.logout + `?curl=https://${window.location.host}/`,
      // 显示备课
      showBkUpdateIcon: false,
      isShowFunction: false,
      windowHeight: 0,
      showScrollIcon: false,
      // isFolded: false,
    };
  },
  watch: {
    userInfo: {
      handler(val) {
        // console.log('val',val)
        let role = val.roles.find(
          (role) => role.simpleName.indexOf("wxt") > -1
        );
        this.isShowFunction = !!role;
      },
      immediate: true,
    },
    menus: {
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            this.handleSideShow();
          });
        }
      },
    },
  },
  inject: ["textbook"],
  computed: {
    ...mapState([
      "currentCourse",
      "userInfo",
      "isFolded",
      "showSyTip",
      "showBkTip",
    ]),
  },
  methods: {
    ...mapMutations([
      "changeIsFolded",
      "changeShowSyTip",
      "changeShowAddBkTip",
    ]),
    handleFirstEnterLinks() {
      let firstEnterLeftLinks =
        localStorage.getItem(FIRSTENTERLEFTLINKS) || false;
      if (this.showScrollIcon && !firstEnterLeftLinks) {
        this.handleScrollBottom();
        localStorage.setItem(FIRSTENTERLEFTLINKS, true);
      }
    },
    handleShowUserRightDetail() {
      if (this.loginStatus && this.enterWxtStatus) {
        this.showUserRightDetail = true;
      }
    },
    userInfoEnter() {
      if (this.loginStatus && this.enterWxtStatus) {
        this.showUserInfoDetail = true;
      }
    },
    openNoAuthDialog() {
      this.$emit("openNoAuthDialog");
    },
    toLoginLayout() {
      this.$emit("toLoginLayout");
    },
    userInfoClick() {
      if (!this.loginStatus) {
        this.$emit("toLoginLayout");
        return;
      }
      if (!this.enterWxtStatus) {
        this.$emit("openNoAuthDialog");
        return;
      }
    },
    handleScrollBottom() {
      let linkWrapper = this.$refs.linkWrapper;
      let boxHeight = this.windowHeight - 262;
      // 获取盒子内容的高度
      var contentHeight = linkWrapper.scrollHeight;
      linkWrapper.scroll({
        top: contentHeight - boxHeight,
        behavior: "smooth",
      });
    },
    judgePathActive(url) {
      // console.log("url", url, url.split("/")[1]);
      // $route.path.indexOf(menu.redirectUrl) > -1
      return this.$route.path.indexOf(url.split("/")[1]) > -1;
    },
    openUserPage() {
      window.open(
        `/user${this.$route.query.xep_flag === "1" ? "?xep_flag=1" : ""}`
      );
    },
    toggle(e) {
      let { item } = e;
      let openSideNavLists = localStorage.getItem(OPENSIDENAVLISTS);
      openSideNavLists = openSideNavLists ? JSON.parse(openSideNavLists) : [];
      console.log("openSideNavLists", openSideNavLists, item.functionId);
      this.$set(item, "isOpen", !item.isOpen);
      // 记录当前展开的父节点
      let currentSideItem = openSideNavLists.find(
        (nav) => nav == item.functionId
      );
      if (!item.isOpen) {
        console.log("收起节点", currentSideItem);
        // 收起节点
        if (currentSideItem) {
          openSideNavLists = openSideNavLists.filter(
            (nav) => nav != item.functionId
          );
        }
      } else {
        // 展开节点
        if (!currentSideItem) {
          openSideNavLists.push(item.functionId);
        }
      }
      localStorage.setItem(OPENSIDENAVLISTS, JSON.stringify(openSideNavLists));
    },
    judgeShowBkUpdateIcon() {
      let startDate = new Date("2023/04/13").getTime();
      let endDate = new Date("2023/04/20").getTime();
      let nowDate = new Date().getTime();
      let showBkUpdateIcon = localStorage.getItem(SHOWBKUPDATEICON);
      if (nowDate >= startDate && nowDate <= endDate && !showBkUpdateIcon) {
        this.showBkUpdateIcon = true;
        // localStorage.setItem(SHOWBKUPDATEICON,true)
      }
      // console.log('startDate',startDate)
    },
    handleShowDownloadErrorVisible(status) {
      this.isShowDownloadErrorVisible = status;
      let callback = () => {
        this.isShowDownloadErrorVisible = status;
      };
      this.textbook.noticeParentPageShowMask(
        status,
        callback,
        ".download-error-dialog"
      );
    },
    handlePath(pathName, functionName) {
      if (!this.loginStatus) {
        this.$emit("toLoginLayout");
        return;
      }
      if (!this.enterWxtStatus) {
        this.$emit("openNoAuthDialog");
        return;
      }
      // console.log("pathNme", pathName);
      let path = this.$route.path;
      if (pathName == "/bk") {
        this.showBkUpdateIcon = false;
        localStorage.setItem(SHOWBKUPDATEICON, true);
      }
      if (pathName == "/desktop") {
        this.changeShowAddBkTip(false);
      }
      if (pathName == "/lab") {
        this.showSyTip && this.changeShowSyTip(false);
      }
      if (path != pathName) {
        this.$emit("toPath", pathName);
      }
      // if (path.indexOf(pathName) == -1) {
      //   this.$emit("toPath", pathName);
      // }
    },
    toPath(e) {
      let { pathName, parentItem } = e;
      // console.log("pathname---", pathName, parentItem, this.menus);
      if (parentItem) {
        this.menus.forEach((item) => {
          // this.$set(
          //   item,
          //   "isOpen",
          //   item.functionId == parentItem.functionId &&
          //     item.functionName == parentItem.functionName
          // );
          this.$set(
            item,
            "isActive",
            item.functionId == parentItem.functionId &&
              item.functionName == parentItem.functionName
          );
          // console.log("item---", item);
        });
      }
      parentItem && this.$set(parentItem, "isOpen", true);
      this.$emit("toPath", pathName);
    },
    jumpRightPage() {
      if (!this.loginStatus) {
        this.$emit("toLoginLayout");
        return;
      }
      if (!this.enterWxtStatus) {
        this.$emit("openNoAuthDialog");
        return;
      }
      window.open(
        `/equity${this.$route.query.xep_flag === "1" ? "?xep_flag=1" : ""}`
      );
    },
    noticeChildPageShowMask() {
      this.textbook.noticeChildPageShowMask();
    },
    handleCheckFold() {
      this.changeIsFolded(!this.isFolded);
      // this.isFolded = !this.isFolded;
    },
    // 打开偏好设置
    openSetting() {
      this.$emit("openSetting");
    },
    changeFeedbackDialogVisible() {
      this.$emit("changeFeedbackDialogVisible", true);
    },
    changeRizhiDialogVisible() {
      this.$emit("changeRizhiDialogVisible", true);
    },
    handleSideShow() {
      this.windowHeight = window.innerHeight || 0;
      let linkWrapper = this.$refs.linkWrapper;
      let boxHeight = this.windowHeight - 262;
      // 获取盒子内容的高度
      if (linkWrapper) {
        var contentHeight = linkWrapper.scrollHeight;
        // console.log("contentHeight", contentHeight, "boxHeight", boxHeight);
        this.showScrollIcon = contentHeight > boxHeight;
      }
    },
    logoClick() {
      if (!this.loginStatus) {
        this.$emit("toLoginLayout");
        return;
      }
      if (!this.enterWxtStatus) {
        this.$emit("openNoAuthDialog");
        return;
      }
      if (this.textbook.isOnlyAiKxRight) {
        return;
      }
      this.$router.push("/desktop");
    },
  },
  mounted() {
    this.judgeShowBkUpdateIcon();
    this.windowHeight = window.innerHeight || 0;
    let url = `https://${window.location.host}/wxtapi/auth/logout?curl=http://${window.location.host}/`;
    // let ekt =
    //   "https://e.xkw.com/ibook/users/logout?logout_sso=true&url=" +
    //   encodeURIComponent(url);
    let lastUrl =
      `https://${beikeHost}/ibook/users/logout?logout_sso=true&url=` +
      encodeURIComponent(url);
    // console.log("lastUrl", lastUrl);
    // let finallUrl = `https://auth.zxxk.com/user/logout?url=${encodeURIComponent(
    //   lastUrl
    // )}`;
    // let finallUrl = `https://beike.xkw.com/ibook/users/logout?logout_sso=true&url=${encodeURIComponent(
    //   ekt
    // )}`;
    this.logoutUrl = lastUrl;
    window.addEventListener("resize", this.handleSideShow);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleSideShow);
  },
};
</script>
<style lang="scss" scoped>
.aside {
  position: fixed;
  width: 130px;
  z-index: 998;
  left: 0;
  top: 0;
  height: 100%;
  background: transparent;

  /* --xkw-shadow-dialog */
  // box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.05), 0px 4px 9px 0px rgba(0, 0, 0, 0.03), 0px 2px 4px 0px rgba(0, 0, 0, 0.02);

  &:hover {
    .dragbar {
      visibility: visible;
    }
  }

  .link-wrapper {
    max-height: calc(100vh - 63px - 36px);
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0 5px;
    /* 修改垂直滚动条 */
    &::-webkit-scrollbar {
      width: 3px; /* 修改宽度 */
      height: 25px;
    }
    /* 修改滚动条轨道背景色 */
    &::-webkit-scrollbar-track {
      background-color: transparent;
    }
    /* 修改滚动条滑块颜色 */
    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.3);
      border-radius: 100px;
    }
  }
  .occupy-box {
    height: 64px;
  }
  .link {
    margin-bottom: 16px;
    padding-top: 10px;
    // width: calc(100% - 30px);
    height: 42px;
    padding: 0 15px;
    display: block;
    // text-align: center;
    // width: 62px;
    // height: 62px;

    line-height: 42px;
    // padding: 0 12px;
    cursor: pointer;
    // z-index: 14;
    position: relative;
    // margin-bottom: 2px;

    .icon {
      // display: block;
      // margin: 0 auto;
      font-size: 20px;
      vertical-align: middle;
      // width: 18px;
      // height: 18px;
      margin-right: 8px;
    }

    .inner-link {
      width: calc(100% - 30px);
      padding: 0 12px;
      border-radius: 6px;

      &:hover {
        background: #eaeef1;
        position: relative;

        .menu-child {
          display: block;

          .active {
            background: #f6f7f9;
            color: #0057ff;
          }
        }
      }
      .red-icon {
        width: 6px;
        height: 6px;
        background: #fe4509;
        border-radius: 50%;
        display: inline-block;
        vertical-align: 10px;
      }
    }
    .alias-name {
      font-size: 12px;
      color: #1a1a1a;
      margin-top: 4px;
      text-align: center;
      line-height: 1;
    }
    .name {
      margin-top: 8px;
      // display: block;
      font-size: 14px;
      color: #333;
      line-height: 12px;
    }

    &.router-link-active {
      // background: #f6f7f9;
      border-radius: 6px;
      position: relative;

      &::after {
        // position: absolute;
        // display: block;
        // right: -3px;
        // top: 27px;
        // content: "";
        // width: 0;
        // height: 0;
        // border-right: 10px solid #0057ff;
        // border-top: 8px solid transparent;
        // border-bottom: 8px solid transparent;
      }

      .inner-link {
        background: #e6f2ff;
      }

      .name {
        color: #0057ff;
      }
    }

    .inner-link {
      // position: absolute;
      width: 100%;
      height: 100%;
      z-index: 1;
    }

    &:first-child {
      margin-top: 25px;
    }

    &:hover {
      .menu {
        display: block;
      }
    }
  }
  .bottom-menu {
    position: absolute;
    bottom: 0px;
    left: 0px;
    width: 100%;
    background: linear-gradient(180deg, #f2f5f7 54.68%, #f1f5fe 100%);
    .right-center {
      width: calc(100% - 24px);
      margin-left: 12px;
      height: 36px;
      // padding: 0px 16px;
      line-height: 36px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #b6915d;
      border-radius: 8px;
      border: 1px solid #b6915d;
      margin-bottom: 20px;
      cursor: pointer;
      i {
        font-size: 12px;
        &.icon-down-arrow {
          display: inline-block;
          // font-size: 12px;
          transform: rotate(-90deg);
        }
      }

      &:hover {
        background: #f4efe7;
        border: 1px solid transparent;
      }
      .right-left {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        // margin-right: 12px;
        i {
          font-size: 20px;
          margin-right: 4px;
        }
        span {
          font-size: 13px;
        }
      }
    }
    &.margin-top-style {
      //  padding-top: 19px;
      .scroll-icon {
        text-align: center;
        line-height: 19px;
        background: #fff;
        cursor: pointer;
        i {
          font-size: 12px;
          color: #0057ff;
        }
      }
    }
    .user-info-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      // background: #0057ff;
      padding-top: 9px;
      margin: 0 12px 8px 12px;
      border-top: 1px solid #d5d9e5;
      // padding: 0 16px;
      // position: relative;
      cursor: pointer;
      .user-info-box {
        height: 46px;
        display: flex;
        align-items: center;
        // justify-content: space-between;
        width: 100%;
        img {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          margin-right: 10px;
        }

        .user-info-name {
          color: #1a1a1a;
          flex: 1;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          // width: 118px;
          .name {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 13px;
          }

          .house {
            color: rgba(255, 255, 255, 0.8);
            font-size: 12px;
          }
        }
        &.no-login {
          text-align: center;
          font-size: 14px;
          color: #fff;
          display: flex;
          justify-content: center;
        }
      }

      i {
        font-size: 16px;
        transform: rotate(-90deg);
        color: #7e7e7e;
        transition: all 0.2s;
      }

      &:hover {
        // background: #669aff;

        i {
          color: #0057ff;
          // transform: rotate(360deg);
        }
      }
      .menu {
        position: absolute;
        bottom: -8px;
        padding-left: 8px;
        left: 130px;
        .menu-inner {
          width: 232px;
          padding: 16px 0 8px;
          // right: -252px;
          // bottom: -8px;
          background: #ffffff;
          border-radius: var(----xkw-medium-radious, 6px);
          background: #fff;
          /* --xkw-shadow-dialog */
          box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.02),
            0px 4px 9px 0px rgba(0, 0, 0, 0.03),
            0px 6px 20px 0px rgba(0, 0, 0, 0.05);
          z-index: 2000;
          .user-info {
            margin: 0 16px;
            display: flex;
            padding-bottom: 12px;
            margin-bottom: 12px;
            border-bottom: 1px solid #e2e2e2;
            img {
              width: 40px;
              height: 40px;
              border-radius: 50%;
              margin-right: 6px;
            }
            .user-info-name {
              flex: 1;
              overflow: hidden;
              .name {
                color: #1a1a1a;
                font-size: 14px;
                line-height: 22px;
                overflow: hidden;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .house {
                color: #7e7e7e;
                font-size: 12px;
                line-height: 20px;
              }
            }
          }
          .menu-group {
            padding: 12px 0;
            position: relative;
            // border-bottom: 1px solid #E2E2E2;
            &:first-child {
              padding-top: 0;
            }

            &::after {
              width: calc(100% - 32px);
              position: absolute;
              height: 1px;
              content: "";
              display: block;
              bottom: 0px;
              left: 16px;
              background: #e2e2e2;
            }
            &:last-child {
              // padding-bottom:0;
              // border-bottom:none;
              &::after {
                display: none;
              }
            }
          }
          .item {
            display: flex;
            align-items: center;
            height: 32px;
            // padding: 0 18px;
            line-height: 32px;
            font-size: 14px;
            padding: 0 16px;
            vertical-align: middle;
            i {
              color: #80848b;
              font-size: 16px;
              margin-right: 8px;
              transform: rotate(0);
              // font-weight: bold;
              vertical-align: middle;
            }

            &:hover {
              background: #f6f7f9;
              // color: #0057ff;
              i {
                // color: #0057ff;
              }
              &:first-child {
                background: #fff;
                color: #7e7e7e;
              }
            }

            &:first-child {
              color: #7e7e7e;
            }
            &.logout {
              color: #7e7e7e;
              &:hover {
                opacity: 0.6;
                i {
                  color: #7e7e7e;
                }
              }
            }
            // &:last-child {
            //   border-radius: 0 0px 4px 4px;
            // }
          }
        }
      }
    }

    .user-info-detail {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 58px;
      background: #fff;
      width: 232px;
      padding: 20px 10px 0px 10px;
      box-shadow: 0px -1px 8px rgba(0, 0, 0, 0.1);
      animation: loading 0.1s;

      .user-info-text {
        border-bottom: 1px solid #e6e7e9;

        & > div {
          // display: flex;
          // align-items: center;
          font-size: 13px;
          overflow: hidden;
          margin-bottom: 20px;
          // flex-wrap: wrap;

          .key {
            color: #80848b;
            width: 39px;
            float: left;
          }

          .value-wrapper {
            float: left;
            width: calc(100% - 39px);
          }

          .value {
            display: block;

            i {
              font-style: normal;
              color: #ff6b00;
            }
          }
        }
      }
      .outter-link {
        padding: 5px 0;
        .link {
          padding: 0;

          .inner-link {
            padding: 0;

            .icon {
              color: #80848b;
            }

            &:hover {
              background: #fff;

              .name {
                color: #80848b;
              }
            }
          }
          &:first-child {
            margin-top: 0px;
          }
        }
      }
    }

    .link {
      // width: 100%;
      // padding: 0 15px;
      // margin: 0;

      // .inner-link {
      //   width: calc(100% - 30px);
      //   padding: 0 12px;
      // }

      &:hover {
        .icon {
          color: #0057ff;
        }

        .name {
          color: #0057ff;
        }
      }

      &:hover {
        .menu {
          display: block;
        }
      }
    }
  }

  &.is-folded-aside {
    width: 64px;
    // padding:6px 0;
    .link {
      width: calc(100% - 24px);
      margin-left: 12px;
      margin-right: 12px;
      padding: 6px 0;
      text-align: center;
      height: auto;
      line-height: 1;
      border-radius: 6px;
      .inner-link {
        padding: 0;
      }
      .icon {
        margin-right: 0px;
      }
      &:hover {
        background: #eaeef1;
      }
      &.router-link-active {
        background: transparent;
        .inner-link {
          background: transparent;
        }
        .alias-name {
          color: #0057ff;
        }
      }
    }

    .bottom-menu {
      .user-info-wrapper {
        padding: 0;

        .user-info-box {
          justify-content: center;
          width: 100%;

          img {
            margin-right: 0;
          }
        }

        .user-info-detail {
          left: 0px;

          .link {
            text-align: left;

            &:first-child {
              margin-top: 0;
            }

            .icon {
              margin-right: 6px;
            }
          }
        }
      }

      .link {
        width: 100%;
        padding: 0 12px;
        margin: 0;

        .menu {
          // right: -124px;
        }
      }
      .right-center {
        width: calc(100% - 24px);
        margin-left: 12px;
        height: 39px;
        padding: 0;
        line-height: 39px;
        text-align: center;
        .right-left {
          margin-right: 0;
          text-align: center;
          i {
            margin-right: 0;
          }
        }
      }
    }
  }

  &.is-show-mask-aside {
    border-right: none;
  }
  &.no-shadow {
    box-shadow: none;
  }

  .link-code {
    // position: absolute;
    // margin: 0 auto;
    // margin-top: 60px;
    // left: 15px;
    // bottom: 8%;
    cursor: pointer;
    width: 60px;
    height: 60px;
    text-align: center;
    background: #f6f7f9;
    border-radius: 6px;
    font-size: 32px;
    text-align: center;
    // line-height: 60px;
    margin: 0 auto;
    margin-bottom: 54px;
    position: relative;

    .bubble-tip {
      position: absolute;
      top: -33px;
      background: #fe4509;
      width: 66px;
      height: 24px;
      left: -10px;
      color: #fff;
      font-size: 13px;
      line-height: 24px;
      text-align: center;
      border-radius: 5px;

      &::after {
        position: absolute;
        display: block;
        content: "";
        width: 0px;
        height: 0px;
        border-width: 5px;
        border-style: solid;
        border-color: #fe4509 transparent transparent transparent;
        bottom: -10px;
        left: 30px;
      }
    }

    .weixin-code {
      position: absolute;
      animation: loading 0.25s ease-out;
      // right: -213px;
      background: #fff;
      z-index: 13;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
      border-radius: 6px;
      // bottom: -42px;
      top: -235px;
      left: -65px;
      width: 190px;
      // height: 224px;
      padding: 8px 8px 14px;

      i {
        position: absolute;
        cursor: pointer;
        top: 6px;
        right: 6px;
        font-size: 12px;
        font-weight: bold;
        color: #80848b;
      }

      p {
        // display: inline-block;
        margin-top: 7px;
        text-align: center;
        font-size: 14px;
        color: #0057ff;
      }

      img {
        width: 174px;
        height: 174px;
      }

      &::after {
        position: absolute;
        content: "";
        display: block;
        width: 0;
        height: 0;
        left: 92px;
        bottom: -6px;
        width: 0px;
        height: 0px;
        border-left: 5px solid transparent;
        border-top: 6px solid #fff;
        border-right: 5px solid transparent;
      }
    }

    svg {
      width: 42px;
      height: 42px;
      margin-top: 9px;
    }

    &:hover {
      svg {
        opacity: 0.6;
      }
    }
  }

  .link-code-mask {
    position: absolute;
    top: 34px;
    left: 0;
    width: 100%;
    height: 40px;
    background: linear-gradient(
      180deg,
      rgba(247, 248, 250, 0.8) 0%,
      rgba(253, 253, 254, 0.2) 100%
    );
    backdrop-filter: blur(2px);
    border-top: 1px solid #fff;
    transition: all 0.3s;

    &.link-code-mask-hover {
      top: 63px;
    }
  }

  .mask {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 50;
  }

  .dragbar {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 20px 6px;
    position: absolute;
    width: 16px;
    height: 42px;
    right: -8px;
    top: 186px;
    background: #ffffff;
    border: 1px solid #e6e7e9;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.06);
    border-radius: 10px;
    visibility: hidden;
    z-index: 49;
    cursor: pointer;
    i {
      color: #80848b;
      font-size: 10px;
      transform: rotate(90deg);
    }

    &:hover {
      i {
        color: #0057ff;
      }
    }

    &.is-folded-dragbar {
      i {
        transform: rotate(-90deg);
      }
    }
  }
}

.menu-child {
  display: none;
  position: absolute;
  top: 0;
  // z-index: 100;
  left: 62px;
  width: 87px;
  background: #ffffff;
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.06);
  border-radius: 6px;
  padding: 10px 0;
  overflow: hidden;

  span {
    line-height: 1;
    padding: 10px 0;
    text-align: center;
    font-size: 12px;
    color: #333333;
    display: block;

    &:hover {
      color: #0057ff;
      background: #f6f7f9;
    }
  }
}

.logo-wrapper {
  // float: left;
  // max-width: 300px;
  display: block;
  // height: 38px;
  padding: 16px 12px;
  // background: #f7f8f9;
  text-align: center;
  cursor: pointer;
  // margin-top: 12px;
  // margin-right: 25px;
  position: relative;
  .logo {
    // position: absolute;
    // top: 0;
    // left: 0;
    width: 106px;
    height: 100%;

    &.mini-logo {
      width: 30px;
      height: 38px;
    }
  }

  .logo-name {
    font-size: 13px;
    color: #666666;
    text-align: center;
    margin-top: 6px;
    // margin-left: -60px;
    // vertical-align: -12px;
  }
  .user-right-wrapper {
    position: absolute;
    left: 130px;
    top: 0;
    padding-left: 8px;
    z-index: 1000;
    .user-right-inner {
      padding: 8px 16px 16px;
      width: 234px;
      border-radius: 6px;
      background: #fff;
      /* --xkw-shadow-dialog */
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.02),
        0px 4px 9px 0px rgba(0, 0, 0, 0.03),
        0px 6px 20px 0px rgba(0, 0, 0, 0.05);
      .menu-group {
        padding-bottom: 12px;
        &:first-child {
          border-bottom: 1px solid #e2e2e2;
          margin-bottom: 12px;
        }
        div {
          text-align: left;
          line-height: 32px;
          &.menu-title {
            color: #7e7e7e;
            font-size: 12px;
          }
          &.menu-info {
            font-size: 14px;
            color: #1a1a1a;
          }
        }
        &:nth-child(2) {
          padding-bottom: 0;
          .menu-info {
            line-height: 22px;
            margin-bottom: 8px;
            span {
              color: #c9a86e;
            }
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }
}

@keyframes loading {
  0% {
    transform: scale(0);
    // bottom: 0;
    // right: -100px;
  }

  100% {
    transform: scale(1);
    // bottom: -42px;
    // right: -213px;
  }
}

@keyframes anTranslate {
  0% {
    // bottom: 0;
    // opacity: 0;
    // z-index: 0;
    transform: scale(0);
    // bottom: 0;
    // right: -100px;
  }

  100% {
    transform: scale(1);
    // bottom: 58px;
    // opacity: 1;
    // z-index: 1;
    // bottom: -42px;
    // right: -213px;
  }
}
</style>
